import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    container: {
        width: "100%",
        display: "flex",
        justifyContent: "flex-end",
        gap: theme.spacing(4),
        marginRight: "32px",
    },
    alert: {
        marginLeft: "16px",
        display: "flex",
        alignItems: "center",
    },
    alertText: {
        fontFamily: "Source Sans 3",
        textAlign: "left",
    },
    buttonCancel: {
        background: theme.palette.secondary.main,
        boxShadow: "0px 2px 0px rgba(62, 93, 138, 0.2)",
        borderRadius: 4,
        border: "none",
        padding: `${theme.spacing(4)} ${theme.spacing(4)}`,
        color: theme.palette.primary.dark,
        cursor: "pointer",
    },
    buttonConfirm: {
        background: theme.palette.info.main,
        boxShadow: "0px 2px 0px rgba(62, 93, 138, 0.2)",
        borderRadius: 4,
        border: "none",
        padding: `${theme.spacing(4)} ${theme.spacing(4)}`,
        color: theme.palette.primary.main,
        cursor: "pointer",
    },
    disabledButton: {
        background: `${theme.palette.border.main} !important`,
        boxShadow: "0px 2px 0px rgba(62, 93, 138, 0.2)",
        borderRadius: 4,
        border: "none",
        padding: `${theme.spacing(4)} ${theme.spacing(4)}`,
        color: theme.palette.primary.main,
    },
    cancelMessage: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(1),
    },
    confirmMessage: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(1),
    },
    icon: {
        fontSize: "22px !important",
    },
}));
